import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { Modal } from "ngx-modal";
import { PaginationInstance } from 'ngx-pagination';
import { AccessLevel } from "../../../common/enums/access-level.enum";
import { Permission } from "../../../common/enums/permission.enum";
import { RowStatus } from "../../../common/enums/row-status.enum";
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { UserInfo } from "../../../shared/interface/user-info.interface";
import { CacheService } from "../../../shared/services/cache.service";
import { CommonService } from "../../../shared/services/common.service";
import { CommonMessage } from "../../common/common-messages";
import { OperatingCountryEnums } from "../../enums/countries.enums";
import { NotificationType } from "../../enums/notification-types.enum";
import { TicketSubtypeModel } from "../../interface/ticketingsystem/ticket-types-model";
import { DeleteModal } from "../../models/delete-modal";
import { CustomerService } from "../../services/customer.service";



@Component({
    selector: "ticketSubType",
    templateUrl: "../../templates/template1/views/configuration/ticketSubType.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/ticketSubType.less"]
})
export class TicketSubType implements OnInit {

    ManageAdminPermissions: any[] = [Permission.MANAGE_DEPARTMENT_CREATE, Permission.MANAGE_DEPARTMENT_VIEW, Permission.MANAGE_DEPARTMENT_EDIT, Permission.MANAGE_DEPARTMENT_DEACTIVATE];

    subtypeForm: FormGroup;
    isUpdate: boolean = false;
    ticketSubTypes: any[];
    ticketTypeInfo: any;
    userInfo: UserInfo;
    isSubmitted: boolean;
    message: string;
    selectedSubtype: any;
    activateDeactivatePopup: DeleteModal;
    clearPopup: DeleteModal;
    subtypeId: number;
    activate: boolean;
    isTicketTypeExist: boolean;
    operatingCountryId: number = 0;
    operatingCountries: any[];
    ticketType: string = this._localStorageService.get('ticketSubType-ticketType') ? this._localStorageService.get('ticketSubType-ticketType') : "";
    ticketSubType: string = this._localStorageService.get('ticketSubType') ? this._localStorageService.get('ticketSubType') : "";
    ticketTypes: any[];
    pageCount: number;
    pageSize: number = 10;
    pageNumber: number = this._localStorageService.get('ticketSubTypePageNumber') ? this._localStorageService.get('ticketSubTypePageNumber') : 1;
    isDesc: boolean = true;
    sortOrder: string = "";
    operatingCountry: number = this._localStorageService.get('ticketSubTypeOperatingCountry') ? this._localStorageService.get('ticketSubTypeOperatingCountry') : 0;
    permission: any = Permission;
    rowStatus: any = RowStatus;

    creatSubTypePermission: boolean;
    editSubTypePermission: boolean;
    viewSubTypePermission: boolean;
    deactivateSubTypePermission: boolean;
    isCountriesLoading = false;
    @ViewChild('subType') input: ElementRef;
    @ViewChild('createSubTicketModal') createSubTicketPopup: Modal;
    constructor(
        private _formbuilder: FormBuilder,
        private _commonService: CommonService,
        private _cacheService: CacheService,
        private _customerservice: CustomerService,
        private _localStorageService: LocalStorageService) {

    }
    ngOnInit(): void {

        this.setFocusToTextBox();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.getOperatingCountries();
        this.isDesc = false;
        this.getTicketSubTypeSearch();
        this.buildForm();
        this.clearPopup = new DeleteModal(this.resetForm.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.clearPopup.viewActionButtons = true;

        this.creatSubTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[0] + "]"), AccessLevel.Account);
        this.viewSubTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[1] + "]"), AccessLevel.Account);
        this.editSubTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[2] + "]"), AccessLevel.Account);
        this.deactivateSubTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[3] + "]"), AccessLevel.Account);

    }
    public paginationInstance: PaginationInstance = {
        id: 'ticket-subtype-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };
    setFocusToTextBox() {

        setTimeout(function () {
            const autoFocusElement = document.getElementById("autofocus-element");
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
        }, 200);
    }

    buildForm() {
        this.subtypeForm = this._formbuilder.group({
            operatingCountryId: ['', Validators.required],
            ticketType: ['', Validators.required],
            ticketSubType: ['', Validators.required],
            ticketSubTypeStatus: [true]
        });
    }

    resetForm() {
        if (this.isUpdate) {
            this.isSubmitted = false;
            this.getTicketSubTypeInfo(this.selectedSubtype);
        } else {
            this.operatingCountryId = 0,
                this.ticketType = this._localStorageService.get('ticketSubType-ticketType') ? this._localStorageService.get('ticketSubType-ticketType') : '',
                this.ticketSubType = this._localStorageService.get('ticketSubType') ? this._localStorageService.get('ticketSubType') : '',
                this.operatingCountry = this._localStorageService.get('ticketSubTypeOperatingCountry') ? this._localStorageService.get('ticketSubTypeOperatingCountry') : 0,
                this.subtypeForm.reset();
            this.buildForm();
        }
        this.pageNumber = 1;
    }
    closePopUp() {
        this.isSubmitted = false;

        this.createSubTicketPopup.close();
    }

    editSubtype(ticketSubTypeId: number) {

        this.isUpdate = true;
        this.isTicketTypeExist = true;
        this.buildForm();
        this.selectedSubtype = ticketSubTypeId;
        this.getTicketSubTypeInfo(ticketSubTypeId);
        this.createSubTicketPopup.open();
        setTimeout(function () {
            const element = document.getElementById("tkttypename-focus");
            if (element) {
                element.focus();
            }
        }, 200);
    }

    getTicketSubTypeSearch() {
        window.document.getElementById("search-button").classList.add('button-active');
        setTimeout(() => {
            window.document.getElementById("search-button").classList.remove('button-active');
        }, 1000);

        if (this.ticketSubType) {
            this._localStorageService.set('ticketSubType', this.ticketSubType);
        }
        if (this.operatingCountry) {
            this._localStorageService.set('ticketSubTypeOperatingCountry', this.operatingCountry);
        }
        if (this.ticketType) {
            this._localStorageService.set('ticketSubType-ticketType', this.ticketType);
        }
        this._localStorageService.set('ticketSubTypePageNumber', this.pageNumber);

        this._customerservice.getTicketSubTypeSearch(this.ticketSubType, this.ticketType, this.operatingCountry, this.isDesc, this.sortOrder, this.pageNumber, this.pageSize).subscribe((response: any) => {
            if (response) {
                this.ticketSubTypes = response["content"];
                this.pageCount = response["totalCount"];
            }
            else {
                this.ticketSubTypes = [];
                this.pageCount = 0;
            }
        });
    }
    sort(sortOrder: string) {
        this.isDesc = (this.sortOrder == sortOrder) ? !this.isDesc : this.isDesc;
        this.sortOrder = sortOrder;
        this.getTicketSubTypeSearch();
    }
    pageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.isDesc = false;
            this.getTicketSubTypeSearch();
        }
    }

    getTicketSubTypeInfo(ticketSubTypeId: number) {
        this._customerservice.getTicketSubtypesById(ticketSubTypeId).subscribe((response: any) => {
            if (response) {
                this.buildForm();
                this.ticketTypeInfo = response;
                this.subtypeForm.patchValue({
                    operatingCountryId: this.ticketTypeInfo.operatingCountry,
                    ticketType: this.ticketTypeInfo.ticketTypeId,
                    ticketSubType: this.ticketTypeInfo.value,
                    ticketSubTypeStatus: (this.ticketTypeInfo.rowStatus == RowStatus.Active) ? true : false
                })
                this.getTicketTypesBasedonOperatingCountry();
            }
        });
    }

    onSubmit(isValid: boolean) {
        this.isSubmitted = true;
        if (isValid) {
            this.isSubmitted = false;
            let ticketSubtypeValues = this.subtypeForm.getRawValue();
            let ticketSubtypeReq = new TicketSubtypeModel();
            ticketSubtypeReq.value = ticketSubtypeValues.ticketSubType.trim();
            ticketSubtypeReq.operatingCountry = ticketSubtypeValues.operatingCountryId;
            ticketSubtypeReq.rowStatus = ticketSubtypeValues.ticketSubTypeStatus ? RowStatus.Active : RowStatus.Inactive;
            ticketSubtypeReq.ticketTypeId = ticketSubtypeValues.ticketType;

            if (this.isUpdate && this.selectedSubtype) {

                ticketSubtypeReq.updatedBy = this.userInfo.userId;
                ticketSubtypeReq.id = this.selectedSubtype;
            }
            else {

                ticketSubtypeReq.createdBy = this.userInfo.userId;
            }
            this.isUpdate ? this.updateTicketSubtype(ticketSubtypeReq) : this.createTicketSubtype(ticketSubtypeReq);
        }
    }
    createTicketSubtype(ticketSubtypeReq: TicketSubtypeModel) {

        this._customerservice.createTicketSubtype(ticketSubtypeReq).subscribe((response: any) => {
            if (response && response.validations.length === 0) {
                this.message = "Ticket Subtype created successfully.";
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
                this.resetForm();
                this.createSubTicketPopup.close();
            }
            else if (response && response.validations.length > 0) {
                this.message = response.validations[0].message;
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            else {
                this.message = "Ticket Subtype creation failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            this.isDesc = false;
            this.getTicketSubTypeSearch();
        });
    }

    updateTicketSubtype(ticketSubtypeReq: TicketSubtypeModel) {

        this._customerservice.updateTicketSubtype(ticketSubtypeReq).subscribe((response: any) => {
            if (response && response.validations.length === 0) {
                this.message = "Ticket Subtype updated successfully.";
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
                this.clearFields();
                this.createSubTicketPopup.close();
            }
            else if (response && response.validations.length > 0) {
                this.message = response.validations[0].message;
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            else {
                this.message = "Ticket Subtype updation failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
        });
    }


    doNotRemoveFormData() {
        //data should not be removed...
    }
    activateOrDeactivateAlert(subtypeId: number, activate: boolean) {
        this.subtypeId = subtypeId;
        this.activate = activate;
        this.activateDeactivatePopup.toggle = true;
        if (activate) {
            this.activateDeactivatePopup.message = CommonMessage.activateMessage;
        }
        else {
            this.activateDeactivatePopup.message = CommonMessage.deactivateMessage;
        }
    }
    clear() {
        this.clearPopup.toggle = true;
        this.clearPopup.message = CommonMessage.clearFormData;
    }
    openCreateSubTicketModal() {
        this.buildForm();
        if (this.isUpdate) {
            this.isUpdate = false;
            this.isTicketTypeExist = false;
        }
        this.createSubTicketPopup.open();
        setTimeout(function () {
            const autoFocusElement = document.getElementById("autofocus-modal-element");
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
        }, 200);
    }
    getOperatingCountries() {
        this.isCountriesLoading = true;
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.isCountriesLoading = false;
                this.operatingCountries = response;
                this.getTicketTypesBasedonOperatingCountry();
                let countryInfo = this.operatingCountries.find((country: any) => country.id === OperatingCountryEnums.USA);
                if (countryInfo) {
                    this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
                    this.operatingCountries.splice(0, 0, countryInfo);
                }
            }
        }, error => {
            this.isCountriesLoading = false;
        });
    }
    getTicketTypesBasedonOperatingCountry() {
        this.ticketTypes = [];
        let operatingCountryId = this.subtypeForm.controls['operatingCountryId'].value;
        if (operatingCountryId) {
            this._customerservice.getTicketTypesByOperatingCountryId(operatingCountryId).subscribe((response: any) => {

                if (response) {
                    this.ticketTypes = response;
                    if (this.isUpdate) {

                        let ticketType = this.ticketTypes.filter((item: any) => item.id === this.ticketTypeInfo.ticketTypeId);

                        ticketType.filter((item: any) => item.id === this.ticketTypeInfo.ticketTypeId);

                        if (ticketType.length === 0) {
                            this.subtypeForm.patchValue({
                                ticketType: ''
                            });
                            this.isTicketTypeExist = false;
                        }
                        else {
                            this.isTicketTypeExist = true;

                        }
                    }


                }
            });
        }
    }


    onSearch() {
        this.pageNumber = 1;
        this.getTicketSubTypeSearch();
    }

    clearFields() {
        this.setFocusToTextBox();
        this.operatingCountryId = 0;
        this.ticketSubType = '';
        this.ticketType = '';
        this.operatingCountry = 0;
        this.pageNumber = 1;
        this.isDesc = false;
        this._localStorageService.remove('ticketSubType');
        this._localStorageService.remove('ticketSubTypeOperatingCountry');
        this._localStorageService.remove('ticketSubTypePageNumber');
        this._localStorageService.remove('ticketSubType-ticketType');
        this.getTicketSubTypeSearch();
    }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/configuration/ticketSubType.component.ts